module.exports = __webpack_public_path__ + "img/movie.1d662c96.svg";